import React, { useState, useEffect } from 'react'
import { getContent } from "../middleware/contentFetch";
import logo from "../assets/images/logo.png";

const Footer = () => {
  const [content, setContent] = useState([]);

  useEffect(() => {
    getContent()
      .then(data => { setContent(data.footer || {}); })
      .catch(() => setContent({}));
  }, []);

  return (
    <div className='bg-dark text-light'>
      <footer className="container justify-content-center">
        <div className="row col-lg-12">
          <div className="col-md-6">
            <div className="card-body">
              <div className="mb-4">
                <img src={logo} alt="" style={{ "width": "40%" }} />
                <h5 className="fw-bold mb-3">Address</h5>
                <p className="mb-1 fs-5">{content['address_line1']}</p>
                <p className="mb-0 fs-5">{content['address_line2']}</p>
              </div>
            </div>
          </div>
          <div className="col-md-4 mt-5">
            <div className="d-flex align-items-center mb-2">
              <div>
                <div className="row col-lg-12">
                  <p className="col-md-3 mb-0 fs-5">Phone: </p>
                  <div className="col-md-9 row">
                    <a href={`tel:${content['phone1']}`} className="fs-5 text-decoration-none">{content['phone1']}</a>
                    <a href={`tel:${content['phone2']}`} className="fs-5 text-decoration-none">{content['phone2']}</a>
                  </div>

                </div>
                <p className="mb-0 fs-5">Email: <a href={`mailto:${content['email']}`} className="text-decoration-none">{content['email']}</a></p>
              </div>
            </div>
          </div>

          <div className="col-md-2 mt-5">
            <h5>{content['section_title1']}</h5>
            <ul className="nav flex-column ">
              <li className="nav-item mb-2"><a href="/" className="nav-link p-0 text-light">Home</a></li>
              <li className="nav-item mb-2"><a href="#about" className="nav-link p-0 text-light">About Us</a></li>
              <li className="nav-item mb-2"><a href="#services" className="nav-link p-0 text-light">Services</a></li>

              <li className="nav-item mb-2"><a href="#productCategory" className="nav-link p-0 text-light">Products</a></li>
              <li className="nav-item mb-2"><a href="#contact" className="nav-link p-0 text-light">Contact Us</a></li>
            </ul>
          </div>

        </div>

        <div className="d-flex justify-content-center mb-0 border-top">
          <p className="mb-0">Crafted and maintained by <strong>Sarojkumar Sahu </strong> © 2026, Inc. All rights reserved.</p>
        </div>
      </footer>
    </div >
  )
}

export default Footer